require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./bibliothque-1-2.json") })
        }
      }, "path---bibliothque-1-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---bibliothque-1-2!./.cache/json/bibliothque-1-2.json
// module id = 347
// module chunks = 231608221292675